/**
 * Ordered lists reserve a fixed gutter for their markers. Past two digits the
 * marker overhangs the text it belongs to, so the gutter widens with the
 * highest number the list will actually render — which depends on `start`, not
 * just the item count.
 *
 * Ported from t3code's `orderedListGutterStyle`.
 */
export function orderedListGutterStyle(
  itemCount: number,
  start: number | undefined,
): { "--list-gutter": string } | undefined {
  const firstNumber = typeof start === "number" && Number.isFinite(start) ? start : 1;
  const lastNumber = firstNumber + Math.max(itemCount - 1, 0);
  const digits = String(Math.abs(lastNumber)).length;
  if (digits <= 2) return undefined;
  return { "--list-gutter": `${digits + 1}ch` };
}
